import * as React from 'react';

import styles from './description-body.module.css';

type Props = {
    children?: React.ReactNode;
    as: string;
};

DescriptionBody.defaultProps = {
    as: 'span',
};

export function DescriptionBody({children, as: Tag}: Props) {
    // @ts-expect-error
    return <Tag className={styles['description-body']}>{children}</Tag>;
}
